<template>
  <div>
    <Header :title="title" :showBack="true" v-if="!isFromTicketChange"></Header>
    <SelectDate v-model:selectDate="ClassDate"></SelectDate>
    <div class="LineClassDaySaleQuery">
      <div class="LineClassName">
        <span>{{ startName }}</span> 开往
        <span>{{ arrivalName }}</span>
      </div>
      <div @click="refundTicketClick" class="refund" v-if="!isHideOperBtn">
        退&nbsp;&nbsp;票
      </div>
      <div @click="SalePaymentClick" class="SalePayment" v-if="!isHideOperBtn">
        售票缴款
      </div>
      <div v-if="AddTicketDisplayState && !isHideOperBtn" class="addTicketDisplay">
        <div class="title">补票模式</div>
        <div class="block">
          <span v-on:click="isChecked = true" class="left" :class="{ current: isChecked == true }">开 启</span>
          <span v-on:click="isChecked = false" class="right" :class="{ current: isChecked == false }">关 闭</span>
        </div>
      </div>
      <div class="lineClassDay-wrapper">
        <div class="wrapper" v-for="item of allTicketArr" v-bind:key="item.id" v-on:click="ticketClick(item)">
          <div class="ticketBlock">
            <span class="circle circle1"></span>
            <span class="circle circle2"></span>
            <span class="circle circle3"></span>
            <span class="circle circle4"></span>
            <span class="circle circle5"></span>
            <div class="ticket">
              <span class="left">{{ item.ClassTime }}</span>
              <span class="right">
                <p>剩{{ item.CanSaleCount }}张</p>
                <p>免童剩{{ item.OverChild }}个</p>
                <p>￥{{ item.FullPrice }}</p>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="none" v-if="allTicketArr.length == 0">暂无该班线数据</div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import SelectDate from "@/components/selectDate";
import dateCalendarStore from "../../stores/dateCalendarStore";
//import { setTimeout } from 'timers';

export default {
  components: {
    Header,
    SelectDate,
  },
  data() {
    return {
      title: "售票详情", //标题
      allTicketArr: [], // 包含所有票的数组
      originArr: [], // 记录allTicketArr的初始值
      ClassDate: dateCalendarStore.state.selectDate || new Date(), // 搜索班次时间
      dataCompleteState: false, // 数据获取的状态
      isChecked: false, // 是否开启补票模式
      state: false, // 补票显示状态 --- true 为 显示补票, false 为不显示补票
      AddTicketDisplayState: true, // 是否显示补票模式按钮
      startName: "", // 上车站点
      arrivalName: "", // 下车站点
      OperObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员 对象
      isFromTicketChange: false, // 是否来自换乘页面
      isHideOperBtn: false, // 默认显示操作按钮，从改乘页面嵌套则不展示
    };
  },
  methods: {
    // 前一天
    onGoBefore() {
      console.log(this.ClassDate.getTime() - 24 * 60 * 60 * 1000);
      if (this.dataCompleteState) {
        this.ClassDate = new Date(
          this.ClassDate.getTime() - 24 * 60 * 60 * 1000
        );
        this.getLineClassDaySaleQuery();
        this.isChecked = false;
      }
    },
    // 后一天
    onGoAfter() {
      if (this.dataCompleteState) {
        this.ClassDate = new Date(
          this.ClassDate.getTime() + 24 * 60 * 60 * 1000
        );
        this.getLineClassDaySaleQuery();
        this.isChecked = false;
      }
    },
    // 获取售票信息
    getLineClassDaySaleQuery() {
      console.log(this.ClassDate);
      const AgentAppID = this.$utils.getSysParams("WindowSaleAgentAppID");
      var StartCityCode = this.$route.params.StartCityCode;
      var StartNodeGID = this.$route.params.StartNodeGID;
      var ArrivalCityCode = this.$route.params.ArrivalCityCode;
      var ArrivalNodeGID = this.$route.params.ArrivalNodeGID;
      this.startName = this.$route.params.StartSelectedName;
      this.arrivalName = this.$route.params.ArrivalSelectedName;
      if (!StartCityCode) {
        StartCityCode = window.sessionStorage.getItem("StartCityCode");
      }
      if (!StartNodeGID) {
        StartNodeGID = window.sessionStorage.getItem("StartNodeGID");
      }
      if (!ArrivalCityCode) {
        ArrivalCityCode = window.sessionStorage.getItem("ArrivalCityCode");
      }
      if (!ArrivalNodeGID) {
        ArrivalNodeGID = window.sessionStorage.getItem("ArrivalNodeGID");
      }
      if (!this.startName) {
        this.startName = window.sessionStorage.getItem("StartSelectedName");
      }
      if (!this.arrivalName) {
        this.arrivalName = window.sessionStorage.getItem("ArrivalSelectedName");
      }
      let params = {
        AgentAppID,
        StartCityCode,
        ArrivalCityCode,
        StartNodeGID,
        ArrivalNodeGID,
        ClassDate: this.ClassDate,
        OperGID: this.OperObj.GID,
      };
      this.dataCompleteState = false;
      this.$http
        .post(this.$api.getLineClassDaySaleQuery, this.$qs.stringify(params))
        .then((res) => {
          //console.log(res);
          this.allTicketArr = JSON.parse(JSON.stringify(res.data));
          this.originArr = JSON.parse(JSON.stringify(res.data));
          //console.log(this.allTicketArr);
          this.sortTime(this.allTicketArr);

          if (res.success) {
            this.dataCompleteState = true;
          }
          this.state = false;
          this.isDisplayAddTicket();
        })
        .catch((err) => {
          //console.log(err);
          this.$dialog.alert({
            title: "提示",
            message: err,
          });
        });
    },
    // 日期和时间排序
    sortTime(time) {
      // 根据售票时间排序 --- 早-晚
      if (this.allTicketArr.length > 0) {
        var sortTime = time;

        sortTime.forEach((item) => {
          item.ClassDate = item.ClassDate.split("-").join("/");
          item.ClassTime = item.ClassTime + ":00";
        });
        // 日期排序
        sortTime.sort(function (a, b) {
          return new Date(a.ClassDate + " " + a.ClassTime).getTime() >
            new Date(b.ClassDate + " " + b.ClassTime).getTime()
            ? 1
            : -1;
        });
        // 改回原有返回格式
        sortTime.forEach((item) => {
          item.ClassDate = item.ClassDate.split("/").join("-");
          item.ClassTime = item.ClassTime.substring(0, 5);
        });
        this.allTicketArr = sortTime;
      }
    },
    // 是否显示补票
    isDisplayAddTicket() {
      // true 为 显示补票, false 为不显示补票
      if (!this.state) {
        // 不显示补票, 筛选掉一部分数据

        const year = new Date().getFullYear();
        const month = new Date().getMonth() + 1;
        const date = new Date().getDate();

        for (let i = 0; i < this.allTicketArr.length; i++) {
          // 判断当天的售票---这里只判断今天
          if (
            parseInt(this.allTicketArr[i].ClassDate.split("-")[0]) === year &&
            parseInt(this.allTicketArr[i].ClassDate.split("-")[1]) === month &&
            parseInt(this.allTicketArr[i].ClassDate.split("-")[2]) === date
          ) {
            // 这里拿到的都是今天的票
            var Hour = parseInt(this.allTicketArr[i].ClassTime.split(":")[0]);
            var Minute = parseInt(this.allTicketArr[i].ClassTime.split(":")[1]);
            if (Hour < parseInt(new Date().getHours())) {
              this.allTicketArr.splice(i, 1);
              i--;
            } else if (
              Hour == parseInt(new Date().getHours()) &&
              Minute <= parseInt(new Date().getMinutes())
            ) {
              this.allTicketArr.splice(i, 1);
              i--;
            }
          }

          // 不显示今天之前的售票
          if (!this.ClassDate) {
            this.ClassDate = new Date()
          }
          if (
            // 昨日月等于今日月，再继续判断日
            (this.ClassDate.getFullYear() <=
              parseInt(new Date().getFullYear()) &&
              this.ClassDate.getMonth() + 1 ==
              parseInt(new Date().getMonth() + 1) &&
              this.ClassDate.getDate() < parseInt(new Date().getDate())) ||
            // 昨日月小于今日月，直接判断为空
            (this.ClassDate.getFullYear() <=
              parseInt(new Date().getFullYear()) &&
              this.ClassDate.getMonth() + 1 <
              parseInt(new Date().getMonth() + 1))
          ) {
            this.allTicketArr = [];
            // console.log('只判断今天之前')
          }
        }
      } else {
        // 显示补票 取回原数组
        this.allTicketArr = JSON.parse(JSON.stringify(this.originArr));
        // console.log(this.originArr)
      }
    },
    doChangeTicket(lineClassDay, changeTicket) {
      //改乘
      this.$http
        .post(
          this.$api.TicketDetailChangeLineClass,
          this.$qs.stringify({
            LineClassDayGID: lineClassDay.GID,
            StartNodeGID: lineClassDay.StartNodeGID,
            ArrivalNodeGID: lineClassDay.ArrivalNodeGID,
            ChangeOrderDetailGIDList: changeTicket.OrderDetailGID,
            OperGID: this.OperObj.GID, //操作员GID
            OperCode: this.OperObj.UserCode, //操作员代码
            OperName: this.OperObj.UserName, //操作员名称
          })
        )
        .then((res) => {
          if (res.success) {
            this.$toast("改乘成功");
            //1s后返回检票列表
            setTimeout(() => {
              // this.$router.replace({
              //    path: "/TicketCheck",
              // });
              this.$router.back(-1);
            }, 1000);
          } else {
            this.$dialog.alert({
              title: "提示",
              message: res.msg,
            });
          }
        });
    },
    // 点击票跳转
    ticketClick(item) {
      //如果存在改乘数据 提示改乘
      let changeTicket = JSON.parse(
        window.localStorage.getItem("changeTicket")
      );
      if (changeTicket) {
        this.$dialog
          .confirm({
            title: "改乘确认",
            message:
              "是否确认将订单：" +
              changeTicket.OrderNo +
              "改乘至" +
              item.ClassDate +
              " " +
              item.ClassTime +
              " " +
              item.StartNodeName +
              "->" +
              item.ArrivalNodeName +
              "的班次",
          })
          .then(() => {
            this.doChangeTicket(item, changeTicket);
          })
          .catch(() => { });
      } else {
        this.$router.push({
          name: "InputPassengers",
          path: "InputPassengers",
          query: {
            GID: item.GID,
            StartNodeGID: item.StartNodeGID,
            ArrivalNodeGID: item.ArrivalNodeGID,
            ClassDate: item.ClassDate,
          },
        });
      }
    },
    // 点击退票按钮
    refundTicketClick() {
      this.$router.push({
        name: "RefundTicket",
        path: "RefundTicket",
        params: {},
      });
    },
    // 点击售票缴款按钮
    SalePaymentClick() {
      this.$router.push({
        name: "SalePayment",
        path: "SalePayment",
        params: {},
      });
    },
  },
  mounted: function () {
    this.getLineClassDaySaleQuery();
    // 加载时获取系统参数---默认是否显示补票
    this.state =
      this.$utils.getSysParams("IsShowExpireClass") == 1 ? true : false;
  },
  watch: {
    isChecked(val) {
      this.state = val;
      this.isDisplayAddTicket();
      this.sortTime();
    },
    ClassDate(val) {
      if (typeof val == "string") {
        this.ClassDate = val = new Date(val);
      }
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let date = val.getDate();
      if (
        year == new Date().getFullYear() &&
        month == new Date().getMonth() + 1 &&
        date > new Date().getDate()
      ) {
        this.AddTicketDisplayState = false;
        // console.log('只判断今天之后,将补票按钮隐藏')
      } else {
        this.AddTicketDisplayState = true;
        // console.log('今天和今天之前的日期,显示补票按钮')
      }
      if (this.dataCompleteState) {
        this.getLineClassDaySaleQuery();
        this.isChecked = false;
      }
    },
  },
  created() {
    if (this.$route.path == "/TicketChange/LineClassDaySaleQuery") {
      this.isFromTicketChange = true;
      this.isHideOperBtn = true;
    }
  },
  // 首页进入初始化仓库
  beforeRouteEnter(to, from, next) {
    if (from.path == "/LineClassDaySale") {
      dateCalendarStore.commit("initializeState", {
        selectDateIndex: 0,
        caldendarDefaultDate: new Date(),
        selectDate: new Date(),
        dateList: [],
      });
    }
    next();
  },
};
</script>

<style scoped lang="less">
[v-cloak] {
  display: none !important;
}

.LineClassDaySaleQuery {
  width: 100%;
  height: auto;

  .date-content {
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    color: #ffb870;
    background-color: #fff;
    font-size: 0.4rem;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 0.2rem;
    position: fixed;
    top: 1.40625rem;
    z-index: 2;

    .left .icon {
      font-size: 0.32rem;
      margin-right: 0.1rem;
      position: relative;
      font-weight: bold;
    }

    .date .icon {
      font-size: 0.4rem;
      position: relative;
      right: 0.1rem;
    }

    .right .icon {
      font-size: 0.32rem;
      margin-left: 0.1rem;
      position: relative;
      font-weight: bold;
    }
  }

  .LineClassName {
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
    font-size: 0.4rem;
    display: flex;
    justify-content: space-between;
    padding: 0 0.4rem;
    box-sizing: border-box;

    span {
      width: 40%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .addTicketDisplay {
    width: 2rem;
    height: auto;
    position: fixed;
    right: 0.2rem;
    bottom: 3.8rem;
    z-index: 2;
    background-color: rgb(253, 152, 52);
    box-shadow: 1px 1px 1px 1px #ccc;

    .title {
      height: 0.86rem;
      line-height: 0.86rem;
      font-size: 0.4rem;
      border-bottom: 1px solid #eee;
      color: #fff;
      background-color: #ccc;
    }

    .block {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      .left {
        flex: 1;
        font-size: 0.4rem;
        background-color: #fff;
        padding: 0.2rem 0;
      }

      .right {
        flex: 1;
        font-size: 0.4rem;
        background-color: #fff;
        padding: 0.2rem 0;
        border-top: 1px solid #eee;
      }

      .current {
        background-color: rgb(253, 152, 52);
        color: #fff;
      }
    }
  }

  .refund,
  .SalePayment {
    width: 2rem;
    height: auto;
    position: fixed;
    right: 0.2rem;
    bottom: 2.4rem;
    color: #fff;
    padding: 0.2rem 0;
    z-index: 2;
    font-size: 0.4rem;
    background-color: #2891e7;
    box-shadow: 1px 1px 1px 1px #ccc;
  }

  .SalePayment {
    bottom: 1rem;
  }

  .none {
    margin-top: 2rem;
    font-size: 0.4rem;
  }

  .wrapper {
    width: 100%;
    height: auto;
    padding: 0.2rem 0.8rem;
    box-sizing: border-box;

    .ticketBlock {
      width: 100%;
      height: 2.6rem;
      position: relative;

      .circle {
        position: absolute;
        width: 0.3rem;
        height: 0.3rem;
        border-radius: 50%;
        background-color: #f1f1f1;
        left: -0.15rem;
      }

      .circle1 {
        top: 0.14rem;
      }

      .circle2 {
        top: 0.64rem;
      }

      .circle3 {
        top: 1.14rem;
      }

      .circle4 {
        top: 1.64rem;
      }

      .circle5 {
        top: 2.14rem;
      }

      .ticket {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        text-align: center;

        .left {
          width: 3rem;
          height: 100%;
          line-height: 2.6rem;
          background-color: #ffb870;
          font-size: 0.7rem;
          color: #fff;
        }

        .right {
          flex: 1;
          height: 100%;
          background-color: #fff;
          display: flex;
          justify-content: space-around;
          flex-direction: column;
          box-sizing: border-box;
          color: #666;

          p:first-child {
            font-size: 0.5rem;
          }

          p:nth-child(2) {
            font-size: 0.4rem;
          }

          p:nth-child(3) {
            font-size: 0.6rem;
            color: #ffb870;
          }
        }
      }
    }
  }
}
</style>
